export const GridDateFormat = "yyyy-MM-dd HH:mm";

export const MAX_COL_WIDTH = 500; // px

export const SearchGridToolbar = ['Search'];

export const ExcelSearchGridToolbar = ['ExcelExport', 'Search'];

export const ExcelFilter = { type: 'Excel' };

export const PageOptions = {
  pageSize: 10, pageSizes: true
};

export const DefaultGridSettings = {
  width: '100%',
  allowSorting: true,
  allowTextWrap: true,
  //allowResizing: true,
  textWrapSettings: { wrapMode: 'Content' },
  enablePersistence: false,
  pageSettings: PageOptions,
  toolbar: SearchGridToolbar,
  className: 'top-align-grid',
};

export const ExtendedGridSettings = {
  width: '100%',
  allowSorting: true,
  allowTextWrap: true,
  textWrapSettings: { wrapMode: 'Content' },
  allowPaging: true,
  allowResizing: true,
  allowReordering: true,
  allowFiltering: true,
  allowExcelExport: true,
  enablePersistence: false,
  pageSettings: PageOptions,
  toolbar: ExcelSearchGridToolbar,
  filterSettings: ExcelFilter,
  className: 'top-align-grid',
};

const px = (v) => {
  if (v == null) return null;
  if (typeof v === 'number') return v;
  if (typeof v === 'string') {
    // handles "133px", "133", ignores percentages
    if (v.endsWith('%')) return null; // skip percent columns
    const n = parseFloat(v.replace('px', ''));
    return Number.isFinite(n) ? n : null;
  }
  return null;
};

export const OnDataBound = async (args) => {
  const grid = args?.component;
  if (grid) {
    await grid.autoFitColumns();
    grid.columns.forEach((col) => {
      if (typeof col.width === 'number' && col.width > MAX_COL_WIDTH) {
        col.width = MAX_COL_WIDTH;
        console.log(col)
      }
    
    });
    
  }
};

export const OnDataBoundFactory = (gridRef) => () => {
  if (gridRef?.current) {
    gridRef.current.columns.forEach((col) => {
      col.maxWidth = MAX_COL_WIDTH + "px";
    });
    gridRef.current.autoFitColumns();
    
  }
};